import React, {Component} from 'react';
import DocumentiTableRow from './DocumentiTableRow'
import TablePager from '../TablePager'
import PropTypes from 'prop-types';
import TableColumnOrdered from '../TableColumnOrdered'

class DocumentiTable extends Component {
    constructor(props) {
        super(props);
        let rv = this.updateData(props.count, props.rowperpage);
        this.state = {
            pages: rv.pages,
            firstPage: 1,
            lastPage: rv.lastPage,
        };
        
        this.onChangePage = this.onChangePage.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let rv = this.updateData(nextProps.count, nextProps.rowperpage);
        this.setState(rv);
    }

    updateData(count, rowperpage){
        let lastPage = Math.ceil(count / rowperpage);
        let pages = [];
        for (let i = 1; i <= lastPage; i++) {
            pages.push(i);
        }
        return {pages, lastPage}
    }


    onChangePage(newpage) {
        switch (newpage)
        {
            case "P":
                if (this.props.page > this.state.firstPage){
                    this.props.onChangePage(this.props.page - 1);
                }
                break;
            case "N":
                if (this.props.page < this.state.lastPage){
                    this.props.onChangePage(this.props.page + 1);
                }
                break;
            default:
                if (this.props.page !== newpage){
                    this.props.onChangePage(newpage);
                }
                break;
        }
    }

    render() {
        return (
            <div className="ep-outer-table">
                <div className="ep-inner-scrollable-table">
                    <table className="ui striped sortable celled  table">
            <thead>
            <tr><th colSpan="9">
                {/*<PrintButton/>*/}
                <TablePager
                    pages={this.state.pages} page={this.props.page}
                    firstPage={this.state.firstPage} lastPage={this.state.lastPage}
                    onChangePage={this.onChangePage}
                />
            </th>
            </tr>
            <tr>
                <TableColumnOrdered
                    name="id"
                    orderActive={this.props.tableOrderingField === "id"}
                    orderFields="c.idDocumento"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >ID</TableColumnOrdered>
                <TableColumnOrdered
                    name="nome"
                    orderActive={this.props.tableOrderingField === "nome"}
                    orderFields="c.nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Nome</TableColumnOrdered>
                <TableColumnOrdered
                    name="anno"
                    orderActive={this.props.tableOrderingField === "anno"}
                    orderFields="c.anno"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Anno</TableColumnOrdered>
                <TableColumnOrdered
                    name="progressivo"
                    orderActive={this.props.tableOrderingField === "progressivo"}
                    orderFields="c.progressivo"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Progr.</TableColumnOrdered>
                <TableColumnOrdered
                    name="commessa"
                    orderActive={this.props.tableOrderingField === "commessa"}
                    orderFields="m.nome, g.nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Commessa/Gara</TableColumnOrdered>
                <TableColumnOrdered
                    name="divisione"
                    orderActive={this.props.tableOrderingField === "divisione"}
                    orderFields="d.nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Divisione</TableColumnOrdered>
                <TableColumnOrdered
                    name="codiceTipoDocumento"
                    orderActive={this.props.tableOrderingField === "codiceTipoDocumento"}
                    orderFields="t.nome"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Tipo</TableColumnOrdered>
                <TableColumnOrdered
                    name="creatoIl"
                    orderActive={this.props.tableOrderingField === "creatoIl"}
                    orderFields="c.creatoIl"
                    orderDirection={this.props.tableOrderingDirection}
                    onChangeOrder={this.props.onChangeOrder}
                >Data creazione</TableColumnOrdered>
                <th className="no-print"></th>
            </tr>
            </thead>
            <tbody>
            {this.props.items.map((item) => (
                <DocumentiTableRow
                    item={item}
                    key={item.idDocumento}
                    onDownload={this.props.onDownload}
                    onDelete={this.props.onDelete}
                    readOnly={this.props.readOnly}
                />
            ))}
            </tbody>
            <tfoot>
            </tfoot>
        </table>
                </div>
            </div>)
    }
}

DocumentiTable.PropTypes = {
    items: PropTypes.array,
    count: PropTypes.number,
    page: PropTypes.number,
    rowperpage: PropTypes.number,
    tableOrderingField: PropTypes.string,
    tableOrderingDirection: PropTypes.oneOf(['A', 'D']),
    onChangePage: PropTypes.func,
    onChangeOrder: PropTypes.func,
    onDownload: PropTypes.func,
    onDelete: PropTypes.func,
    readOnly: PropTypes.bool
}
export default DocumentiTable;




/** WEBPACK FOOTER **
 ** ./src/components/documenti/DocumentiTable.js
 **/